module.exports = __webpack_public_path__ + "static/media/house3lg.23bf935d.png";